export const getImageUrl = name => `/${__STATIC_DIRECTORY__}/img/${name}`;

export const transformPhoneValueInput = value => value?.replace(/ /g, '');

export const t = data => {
  const type = typeof (data);

  if (type === 'string') {
    return window.authTranslation?.[data];
  }

  if (type === 'object') {
    return `${window.authTranslation?.[data.code]} ${data.additionalMessage}`;
  }

  return '';
};

export const getClasses = classNamesObj => {
  const classNames = Object.keys(classNamesObj);

  return classNames.reduce((acc, className) => (classNamesObj[className] ? `${acc} ${className}` : acc), '');
};

export const compose = (...fns) => arg => fns.reduce((composed, f) => f(composed), arg);
